import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { getErrorText } from 'src/app/service/ansokan-form-builder/validator-errors';

@Component({
    selector: 'app-input',
    templateUrl: './input.component.html',
    standalone: false
})
export class InputComponent implements OnInit {

  @Input() public control: UntypedFormControl;
  @Input() public type = 'text';
  public localGroup: UntypedFormGroup;

  constructor(private fb: UntypedFormBuilder) { }

  public ngOnInit() {
    this.localGroup = this.fb.group({ control: this.control });
  }

  public get error(): string {
    return getErrorText(this.control);
  }

  public get classes() {
    return {
      'skv-form-control': true,
      'skv-form-control--error icon-error': this.control && this.control.invalid && this.control.touched,
    };
  }
}
